import { useQuery } from '@apollo/client/react'
import { SearchSelect } from '@src/components/Elements/SearchSelect'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { PlotStatusNodeConnection } from '@src/generated/schema'
import { SearchSelectProps } from '@src/components/Elements/SearchSelect/SearchSelect'
import { Plot } from '@src/graphql/Plot'

export const StatusSelect: FC<Pick<SearchSelectProps, 'required'>> = (props) => {
  const { t } = useTranslation()
  const { data, loading } = useQuery<{ plotStatus: PlotStatusNodeConnection }>(Plot.getPlotStatus)
  const { plotStatus: { edges } = { edges: [] as any } } = data || {}

  return (
    <SearchSelect
      {...props}
      label={t('desktop.pages.plots.filter.status.title')}
      options={edges.map(({ node: { status } }) => ({
        title: t(`desktop.pages.plots.list.status.${status}`),
        value: status.toLowerCase(),
      }))}
      name='status'
      loading={loading}
    />
  )
}
